(function($) {

	$.loadComplete = function(cb) {
		var fired = false;

		function func(e) {
			// console.log(e.type);
			if (fired)
				return;

			fired = true;
			cb($);
			if (e.type == 'load')
				$(window).trigger('load');
		}

		$(document).ready(func);
		$(window).on('load', func);
	};

})(window.jQuery);
//WINDOW VIEWPORT
//Fixes issues with CSS and JS not matching up at browser/window sizes due to the scrollbar.
(function($) {
	var e = window, a = 'inner';
	if (!('innerWidth' in window )) {
		a = 'client';
		e = document.documentElement || document.body;
	}

	$.fn.viewport = function(options) {
		if (this.get(0) != window)
			return { width: this.outerWidth(), height: this.outerHeight() };
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};

	$.fn.viewportWidth = function(options) {
		if (this.get(0) != window)
			return this.outerWidth();
		return e[ a+'Width' ];
	};

	$.fn.viewportHeight = function(options) {
		if (this.get(0) != window)
			return this.outerHeight();
		return e[ a+'Height' ];
	};

	$.fn.filterByData = function(prop, val) {
		this.filter(
			function() { return $(this).data(prop)==val; }
			);
	};
})(jQuery);
jQuery.loadComplete(function($) {
	// Global vars
	var windowWidth = 0,
	windowHeight = 0,
	$scrollTop = 0,
	// loading = true,
	$self, 
	$this,
	$window = $(window),	
	$document = $(document),	
	body = $('body'),
	header = $('.header'),
	main = $('.main'),
	footer = $('.footer');

	/*====================================
	Window Events
	====================================*/

	$window.resize(function(e) {
		//Causes resize not to fire if the windows haven't actually changed (great for IE8)
		// if (windowWidth != $window.viewportWidth() || windowHeight != $window.viewportHeight()) {
		windowWidth = $window.viewportWidth();
		windowHeight = $window.viewportHeight();

			//Code goes here
		main.css('min-height', windowHeight - ( header.outerHeight(true) + footer.outerHeight(true) ) );
		// console.log(windowHeight);
		// console.log(windowWidth);
		// console.log(header.outerHeight(true));
		// console.log(footer.outerHeight(true));

		// }
	}).resize();

	/*====================================
	Document Events
	====================================*/

	$document.scroll(function(e) {
		$scrollTop = $document.scrollTop();
		body.toggleClass('scrolled', $scrollTop > 100);
		// console.log(scrollTop);
	});

	//stops the browser loading delay 
	// setTimeout(function() {
	// 	loading = false;
	// }, 500);

	$('.lightbox-trigger').featherlight({
		targetAttr: 'href'
	});
	$('.lightbox-video-trigger').featherlight({
		targetAttr: 'href',
		variant:    'featherlight-video', 
	});

	$('.learn-more-video-lightbox').featherlight({
		variant:    'featherlight-video', 
	});

});//End doc.ready

// $(window).on('load', function (e) {
// 	$(window).resize();
// });